"use client";

import { Leaf, Droplets, Recycle, Award, Wind } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCredentials() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: itemsRef,
    isVisible: itemsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const credentials = [{
    icon: Award,
    label: "LICENSED & INSURED",
    description: "Licensed and insured professionals for your peace of mind."
  }, {
    icon: Leaf,
    label: "FAMILY OWNED",
    description: "Local values and dedicated personal service."
  }, {
    icon: Droplets,
    label: "ECO-FRIENDLY",
    description: "Treatments applied with care around your family and pets."
  }, {
    icon: Wind,
    label: "FREE INSPECTIONS",
    description: "Comprehensive property audits at no cost."
  }, {
    icon: Recycle,
    label: "SATISFACTION",
    description: "Dependable service and attentive follow-through."
  }];
  return <section data-section-id="4418" id="our-credentials" className="relative overflow-hidden bg-background text-foreground py-20 md:py-28 lg:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 md:h-96 md:w-96 opacity-10 blur-3xl" style={{
      backgroundColor: "var(--primary)"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs tracking-[0.15em] uppercase mb-6 font-bold" style={{
          color: "var(--primary)"
        }}>
            The Gold Standard
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight text-foreground font-semibold" style={{
          fontFamily: "var(--font-serif)"
        }}>
            Protection defined by <span className="italic" style={{
            color: "var(--primary)"
          }}>precision</span>.
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed font-default" style={{
          color: "var(--chart-3)"
        }}>
            From attic to basement, we deploy technical expertise and premium 
            solutions to ensure your home remains a pristine sanctuary.
          </p>
        </div>

        {}
        <div ref={itemsRef} className="relative mt-20 sm:mt-16 md:mt-24">
          {}
          <div aria-hidden="true" className="hidden md:block absolute left-0 right-0 top-[60px] h-px" style={{
          backgroundColor: "var(--border)",
          opacity: 0.5
        }} />

          {}
          <div aria-hidden="true" className="md:hidden absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2" style={{
          backgroundColor: "var(--border)",
          opacity: 0.5
        }} />

          <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {credentials.map((item, i) => {
            const Icon = item.icon;
            return <div data-index={i} key={item.label} className={`relative flex flex-col items-center text-center px-2 transition-all duration-700 ease-out ${itemsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: `${i * 120}ms`
            }}>
                  {}
                  {i < credentials.length - 1 && <div aria-hidden="true" className="hidden md:block absolute right-0 top-8 bottom-8 w-px translate-x-2" style={{
                backgroundColor: "var(--border)",
                opacity: 0.3
              }} />}

                  {}
                  <div className="relative flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 lg:w-[120px] lg:h-[120px] rounded-md bg-background border border-border shadow-sm">
                    <Icon strokeWidth={1.5} className="w-10 h-10 md:w-12 md:h-12" style={{
                  color: "var(--primary)"
                }} aria-hidden="true" />
                  </div>

                  <h3 className="mt-5 font-default text-[10px] sm:text-[11px] lg:text-xs tracking-[0.15em] uppercase text-foreground font-bold">
                    {item.label}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed max-w-[180px] font-default" style={{
                color: "var(--chart-3)"
              }}>
                    {item.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}